import { Operation } from '@utils/index'
import List from '@utils/list'
const { Table } = List
import Form from '@utils/form'
import { changeSrmSupplierFormula, cancelSrmSupplierFormula } from '@/api/performance/index'

const form = new Form('performance.supplierFormula')
  .add('formulaName').label('formulaId').select('/srmGeneralFormula/getSrmGeneralFormulaPageByParams').col(24)

const table = new Table('performance.supplierFormula', true)
  .add('purOfficeName')
  .add('supOfficeName')
  .add('formulaId').format(({ row, value }) => { return row['formulaName'] || (value !== 0 ? value : '') })

async function setting(this: any, vm: any) {
  const { row, data } = vm
  const formulaId = data.formulaName
  row.formulaId = formulaId
  if (formulaId) {
    await changeSrmSupplierFormula({ id: row.id, formulaId })
  } else {
    await cancelSrmSupplierFormula({ id: row.id })
  }
  this.search()
}

const operation = new Operation('performance.supplierFormula')
  .add('setting').form(form, setting, { width: '300px' })

export default new List()
  .url('/srmSupplierFormula/getSrmSupplierFormulaPageByParams', process.env.VUE_APP_PURCHASE_API)
  .table(table)
  .operation(operation)
  .end()
